// extracted by mini-css-extract-plugin
export default {"inline":"TaskResponsible_inline__I-0HX","task_responsible":"TaskResponsible_task_responsible__mDjyi"};